import React from 'react';
import { Chart as ReactChart } from 'react-chartjs-2';
import './chart-wrapper.scss';
/**
 * ChartWrapper component to handle chart rendering
 */
const ChartWrapper: React.FC<any> = (props) => {
  // The Chart component from react-chartjs-2 accepts a 'type' prop directly
  // along with data and options
  return (
    <div className='component-chart-wrapper'>
      <ReactChart {...props} />
    </div>
  );
};

export default ChartWrapper;
